import React from 'react';
import PropTypes from 'prop-types';
import {notification, message} from 'antd';
import MaterialIcon from 'components/common/MaterialIcon';


const show = (id = 0, title = 'Title', description = 'Content', icon = 'deskphone', status = 'success', callback = (id) => {
  console.log('close', id);
}) => {

  let state = Object.assign({}, {
    type: 'notification',
    duration: 0,
    icon: 'yes',
    placement: 'bottomLeft',
  }, app.local.load('notification'));

  let borderColor;
  let backgroundColor;
  switch (status) {
    case 'success':
      borderColor = '#009900';
      backgroundColor = '#d0ffd0';
      break;
    case 'error':
      borderColor = '#990000';
      backgroundColor = '#ffd0d0';
      break;
    case 'waiting':
      borderColor = '#000099';
      backgroundColor = '#d0d0ff';
      break;
    default:
      borderColor = '#999999';
      borderColor = '#eeeeee';
  }

  if (state.type === 'notification') {
    let args = {
      message: title,
      description: description,
      duration: state.duration,
      placement: state.placement,
      style: {
        background: backgroundColor,
        boxShadow: '0px 3px 2px rgba(0,0,0,0.5)',
        borderBottom: `5px solid ${borderColor}`,
      },
      onClose: () => callback(id),
    };
    if (state.icon === 'yes') {
      args = Object.assign({}, args, {icon: <MaterialIcon name={icon} style={{color: '#444444'}}/>});
    }
    notification.open(args);
  } else {
    let duration = state.duration === 0 ? 1 : state.duration;

    switch (status) {
      case 'success':
        message.success(`${title} - ${description}`, duration, () => {
          callback(id);
        });
        break;
      case 'error':
        message.error(`${title} - ${description}`, duration, () => {
          callback(id);
        });
        break;
      case 'waiting':
        message.warning(`${title} - ${description}`, duration, () => {
          callback(id);
        });
        break;
      default:
        message.info(`${title} - ${description}`, duration, () => {
          callback(id);
        });
    }
  }
};
@autobind
/**
 *
 */
export default class Notification extends React.PureComponent {
  static render = (item, callback) => {
    switch (item.notifiableType) {
      case 'Api\\TA\\Modules\\Device\\Models\\Device':
        show(item.id,
          app.translate('components.common.notification.Device', item.data),
          item.data && item.data.all !== undefined ? app.translate('components.common.notification.Device Data', item.data) : '---',
          'deskphone',
          item.status, callback);
        break;
      default:
        show(item.id, item.status, item.notifiableType, 'note', item.status, callback);
    }
  };
}
